module.exports = __webpack_public_path__ + "img/c7.ee890b39.jpg";